import { filter, maxBy } from 'lodash';
import componentQueries from 'react-component-queries';

/**
 * Wraps a component with a div that will have a classname applied
 * according to the componentSizeDefns passed in.
 *
 * @param componentSizeDefns
 * @param cssTemplateBlock      - you may access sizeId as a prop to customize the styling behavior
 * @return {Function}
 * @constructor
 */
export default function CreateResponsiveStyledComponent(componentSizeDefns) {
    return function wrapComponent(WrappedComponent) {
        return componentQueries((size, { width }) => {
            // the `|| width` part is purely for unit testing purposes
            const qualifyingSizeDefns = getQualifyingSizeDefns(componentSizeDefns, size.width || width);

            return { sizeId: getComponentSizeDefn(qualifyingSizeDefns).ID };
        })(WrappedComponent);
    };
}

export function getQualifyingSizeDefns(componentSizeDefns, pixelSize) {
    // find matching size definition
    const qualifyingSizeDefns = filter(componentSizeDefns, sizeDefn => pixelSize >= sizeDefn.MIN_SIZE);

    // put the first one by default if none match
    return qualifyingSizeDefns.length ? qualifyingSizeDefns : [componentSizeDefns[0]];
}

export function getComponentSizeDefn(qualifyingSizeDefns) {
    return maxBy(qualifyingSizeDefns, sizeDefn => sizeDefn.MIN_SIZE);
}
